//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    //  Articles
    import ArticleFull from "../formats/ArticleFull";
	import ArticleBrief from "../formats/ArticleBrief";
	import ArticleDefault from "../formats/ArticleDefault";


	//  Components
    import GameBox from "../../rugby/games/GameBox";
    import LiveBlock from "../../rugby/lives/LiveBlock";

	//  Carousel
	import { Carousel, Slide } from 'vue-carousel';

	export default {
		name: "articles",
        props: ['entries', 'home'],
        data() {
            return {
            	user: Object,
				teams: [],
                teamSelected: null,
                advertiser: null,
                displayAds: true,
            };
        },

        components: {LiveBlock, GameBox, ArticleDefault, ArticleFull, ArticleBrief, Carousel, Slide},

        created() {
		    this.displayAds = this.$root.display;
            this.advertiser = window.rugbyAdvertiser;
        },
        mounted() {
			this.teamSelected = localStorage.getItem('favorite_club');
			/*
			if( this.home && !this.teamSelected ) {
				this.getTeams();
			}
			*/
			this.user = User;
        },

        computed: {
		    /*
			displayAds: function() {
				return this.home && (!this.user.isConnected || (this.user.isConnected && !this.user.isPremium ));
            },
            */
        },

        methods: {
			 getTeams() {
				try {
					window.Api.get('rugby/clubs').then(response => {
						let teams = response.data.teams;

						teams['top-14'].teams.forEach((team) => {
							this.teams.push(team);
						});

						teams['pro-d2'].teams.forEach((team) => {
							this.teams.push(team);
						});
                    });
				} catch(e) {
					console.log(e);
				}
			},

             selectTeam(id) {
				try {
					window.Api.get('api/select-team/' + id).then(response => {
						if( response.success ) {
							localStorage.setItem('favorite_club', response.data.team.id);
                            window.Vue.notify({
								group: 'default',
								text: response.message,
                                type: 'success',
							});
                        } else {
                            window.Vue.notify({
								group: 'default',
								text: response.message,
								type: 'error',
							});
                        }
                    })
                } catch(e) {
					console.log(e);
                }
            },

			displayArticle: function(sponsored) {
			 	if( this.user.isConnected ) {
			 		if( this.user.isPremium && !this.user.display_sponsors ) {
			 			if( sponsored ) {
			 				return false;
                        }
                        return true;
                    }
                    return true;
                }
                return true;
			}
        }
	}
